export const loginDesktopStyle = {
  content: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'hidden',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '0',
    width: '400px',
    height: 'max-content',
    minHeight: '500px',
    margin: 'auto',
    transform: 'none',
  },
}

export const loginMobileStyle = {
  content: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '0',
    width: '90vw',
    height: 'min-content',
    minHeight: '500px',
    margin: 'auto',
    transform: 'none',
  },
}
export const signUpDesktopStyle = {
  content: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'hidden',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '20px',
    width: '400px',
    height: 'max-content',
    minHeight: '400px',
    margin: 'auto',
    transform: 'none',
  },
}

export const signUpMobileStyle = {
  content: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'hidden',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    // padding: '0',
    width: '90vw',
    height: 'min-content',
    minHeight: '400px',

    margin: 'auto',
    transform: 'none',
  },
}

export const signUpSmallMobileStyle = {
  content: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    // padding: '0',
    width: '90vw',
    height: '90vh',
    minHeight: '400px',

    margin: 'auto',
    transform: 'none',
  },
}
